import { Prompt } from '@server/prompts';

export type CategoryFormMode = 'create' | 'edit' | null;

export interface CategoryFormState {
  mode: CategoryFormMode;
  editingCategoryId: string | null;
}

export interface CategoryData {
  name: string;
  description: string;
}

export interface PromptWithCategory extends Prompt {
  categoryName: string;
  categoryId: string;
}

export enum PromptViewMode {
  list = 'list',
  create = 'create',
  edit = 'edit',
}

export type PromptViewState =
  | { mode: PromptViewMode.list }
  | { mode: PromptViewMode.create; initialCategoryId: string | null }
  | { mode: PromptViewMode.edit; prompt: PromptWithCategory };
